// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const assetAssignmentStatusSchema = z.enum([
  'upcoming',
  'active',
  'past',
  'none',
]);

export const ASSET_ASSIGNMENT_STATUSES = assetAssignmentStatusSchema.options;

export type AssetAssignmentStatus = z.infer<typeof assetAssignmentStatusSchema>;

export const ASSET_ASSIGNMENT_STATUS_LABELS: Record<
  AssetAssignmentStatus,
  string
> = {
  upcoming: 'Upcoming project',
  active: 'Active project',
  past: 'Past project',
  none: 'No project',
};
